export const isPasswordStrong = (password: string) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/.test(password)

export const withLettersOnly = (s: string, allowSpaces = false) =>
  allowSpaces ? /^[A-Za-z ]+$/.test(s) : /^[A-Za-z]+$/.test(s)

export default {
  isPasswordStrong,
  withLettersOnly
}



// WEBPACK FOOTER //
// ./src/services/validate.ts